import React from 'react';

import type { ILeavePromptState, LeavePromptAction } from './types';

type ILeavePromptContext = [ILeavePromptState, React.Dispatch<LeavePromptAction>];

// The default context value should not be used anywhere.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const LeavePromptContext = React.createContext<ILeavePromptContext>(undefined!);
